'use strict';

angular.module('far.models.document', [])
    .service('Document', function ($log, $http) {
        var types = [],
            typeComplete = false,
            kinds = [],
            kindComplete = false,
            committees = [],
            committeeComplete = false,
            new_committees = [],
            new_committeesComplete = false,
            years = [],
            yearComplete = false;

        Object.defineProperty(this, 'types', {
            get: function () {
                if (!typeComplete) {
                    typeComplete = true;

                    $http.get(Routing.generate('api_get_document_type'))
                        .then(function (response) {
                            response.data.forEach(function (routeData) {
                                types.push(routeData);
                            });
                        }, function errorCallback(response) {
                            $log.error(response);
                        });
                }

                return types;
            }
        });

        Object.defineProperty(this, 'kinds', {
            get: function () {
                if (!kindComplete) {
                    kindComplete = true;

                    $http.get(Routing.generate('api_get_document_kind'))
                        .then(function (response) {
                            response.data.forEach(function (routeData) {
                                kinds.push(routeData);
                            });

                        }, function errorCallback(response) {
                            $log.error(response);
                        });
                }

                return kinds;
            }
        });

        Object.defineProperty(this, 'committees', {
            get: function () {
                if (!committeeComplete) {
                    committeeComplete = true;

                    $http.get(Routing.generate('api_get_document_committee'))
                        .then(function (response) {
                            response.data.forEach(function (routeData) {
                                committees.push(routeData);
                            });
                        }, function errorCallback(response) {
                            $log.error(response);
                        });
                }

                return committees;
            }
        });


        Object.defineProperty(this, 'new_committees', {
            get: function () {
                if (!new_committeesComplete) {
                    new_committeesComplete = true;

                    $http.get(Routing.generate('api_committee_get_committees'))
                        .then(function (response) {
                            response.data.forEach(function (routeData) {
                                new_committees.push(routeData);
                            });
                        }, function errorCallback(response) {
                            $log.error(response);
                        });
                }

                return new_committees;
            }
        });

        Object.defineProperty(this, 'years', {
            get: function () {
                if (!yearComplete) {
                    yearComplete = true;

                    $http.get(Routing.generate('api_get_document_year'))
                        .then(function (response) {
                            response.data.forEach(function (routeData) {
                                years.push(routeData);
                            });
                        }, function errorCallback(response) {
                            $log.error(response);
                        });
                }

                return years;
            }
        });

        this.new = function (data) {
            return new Document(data);
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_delete_document', {document: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.restore = function (route) {
            return $http.patch(Routing.generate('api_patch_document', {id: route.id}))
                .then(function () {
                    return route = null;
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.get = function (id, callback) {
            var route = new Document({});

            $http.get(Routing.generate('api_get_document', {document: id}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function Document(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_document', {document: this.id}) :
                                Routing.generate('api_post_document');

                        // TODO: Грязный хак
                        var data = angular.merge({}, this);

                        var objectToId = [
                            'disciplines',
                            'types',
                            'kinds',
                            'committees',
                            'new_committees',
                        ];

                        for (var key in objectToId) {
                            var dataName = objectToId[key];

                            data[dataName] = data[dataName].map(function (value) {
                                return value.id;
                            });
                        }

                        if (data.hasOwnProperty('file')) {
                            data['file'] = data['file'].id;
                        }

                        return $http[method](url, data);
                    }
                }
            });
        }
    });
